<style lang="stylus" scoped>
  span
    margin 0px 15px
    border-bottom 3px solid transparent
    color #999999
    display inline-block
    height auto 
    line-height 2
    color #000000
    font-size 20px
  span.active
    border-color #336CAF
    color #326DAF
</style>
<template>
    <el-col :span="12">
        <div class="title">
            <span
            >车辆注册省</span>
        </div>
    </el-col>
</template>
<script>
    export default {
        computed:{
            titleArr:function(){
                return this.$store.state.app.titleArr
            },
            tab:function(){
                return this.$store.state.app.tab
            }
        },
        methods:{
            titClick(index){
                this.$store.commit('SET_TAB',index)
            }
        }
    }
</script>
